webpackJsonp([162686845683984],{

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookConnections = __webpack_require__(35);
	
	var _LoreHookConnections2 = _interopRequireDefault(_LoreHookConnections);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookConnections2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'models'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This establishes the default configuration for all ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'models'
	      ),
	      ' that use this connection. You can pass in any options that are supported by ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'models'
	      ),
	      '. For a list of options, see the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/architecture/models/' },
	        'model documentation'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-connections-config-models-js-79f45944a8161a40b2f9.js